module.exports = "./img/desktop_logo.20ebd5d.png";